import { Box, FormControl, WarningOutlineIcon } from "native-base";

const InputErrorMessage = ({ errorMessage = "Enter details" }) => {
  return (
    <Box>
      <FormControl.ErrorMessage leftIcon={<WarningOutlineIcon size="xs" />}>
        {errorMessage}
      </FormControl.ErrorMessage>
    </Box>
  );
};

export default InputErrorMessage;
